import React, { useCallback } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from '@mui/material';
import { useStackModalContext } from '../context/StackModalContext';

const DeleteConfirmationDialog: React.FC = () => {
  const {
    state: { controlModes, isDeleteConfirmOpen, controlModeToDelete },
    actions: {
      controlMode: { handleDeleteControlMode, handleCloseDeleteConfirm },
    },
  } = useStackModalContext();

  // Handle confirming the delete
  const handleConfirmDelete = useCallback(() => {
    if (controlModeToDelete !== null) {
      handleDeleteControlMode(controlModeToDelete);
      handleCloseDeleteConfirm();
    }
  }, [controlModeToDelete, handleDeleteControlMode, handleCloseDeleteConfirm]);

  return (
    <Dialog open={isDeleteConfirmOpen} onClose={handleCloseDeleteConfirm}>
      <Box sx={{ p: 2, pb: 0 }}>
        <Typography variant='h6'>Confirm Delete Control Mode</Typography>
      </Box>
      <DialogContent>
        <DialogContentText>
          {controlModeToDelete !== null && controlModes[controlModeToDelete]
            ? `Are you sure you want to delete the control mode "${controlModes[controlModeToDelete].name}"?`
            : 'Are you sure you want to delete this control mode?'}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDeleteConfirm} color='primary'>
          Cancel
        </Button>
        <Button onClick={handleConfirmDelete} color='primary' autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(DeleteConfirmationDialog);
